import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardEngineService {
  private http = inject(HttpClient);

  getWidgetData(type: string, widgetId: string, filters: any = {}): Observable<any> {
    return this.http.get(`api/dashboards/${type}/widgets/${widgetId}`, { params: this.buildParams(filters) });
  }

  private buildParams(filters: any): any {
    const params: any = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params[key] = filters[key];
      }
    });
    return params;
  }
}
